import { Component } from '@angular/core';
import { ListRendererWidgetBase } from '@capturum/builders/list-renderer';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-completed-widget',
  standalone: true,
  imports: [CommonModule],
  template: `<i class="fas fa-check-circle completed-icon"></i>`,
  styleUrls: ['./completed-widget.component.scss'],
})
export class CompletedWidgetComponent extends ListRendererWidgetBase {}
